import CryptoJS from "crypto-js";

export function encryptMD5UpperCase(text) {
    return CryptoJS.MD5(text).toString().toUpperCase();
}
